import { useQuery } from 'react-query';
import { QueryKeys } from 'utils/queryKeys';
import { apiDocumentServiceRepository } from 'services/repositories/implementations/ApiDocumentServiceRepository';

export function useInstalledFonts(contentId: string) {
  // Note: we don't pass contentId as a query key since they're installed per-account.
  // Ref: https://github.com/proposify/editor-mfe/pull/170#issuecomment-5452904569
  const { data, isError, isFetched } = useQuery(QueryKeys.fonts, () => apiDocumentServiceRepository.getInstalledFonts(contentId), {
    staleTime: Infinity,
    enabled: !!contentId,
  });
  const result = !data ? [] : data;
  return {
    result,
    isError,
    isFetched,
  };
}
